import React, { useContext, useEffect } from "react";
import { Checkbox } from "@mui/material";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const SelectMessageCheckbox = ({ message, classes }) => {
    const [isChecked, setIsChecked] = React.useState(false);
    const { 
      setSelectedMessages,
      selectedMessages,
      isSelectionMode
   } = useContext(ForwardMessageContext);

    const handleSelectMessage = (e, message) => {
        const list = [...selectedMessages];
        if (e.target.checked) {
          setIsChecked(true);
          list.push(message);
        } else {
          const index = list.findIndex((m) => m.id === message.id);
          if (index > -1) {
            list.splice(index, 1);
          }
          setIsChecked(false);
        }
        setSelectedMessages(list);
      }

    // Sincronizar o estado do checkbox com as mensagens selecionadas
    useEffect(() => {
        const isMessageSelected = selectedMessages.some(m => m.id === message.id);
        setIsChecked(isMessageSelected);
    }, [selectedMessages, message.id]);
    
    if (isSelectionMode) {
        // Determinar posição baseada no tipo da mensagem
        const isFromMe = message.fromMe;
        const checkboxClass = isFromMe ? classes.messageCheckboxRight : classes.messageCheckboxLeft;
        
        return (
            <div className={checkboxClass}>
                <Checkbox 
                    color="primary" 
                    size="small"
                    checked={isChecked} 
                    onChange={(e) => handleSelectMessage(e, message)}
                    sx={{
                        padding: '2px',
                        '& .MuiSvgIcon-root': {
                            fontSize: '18px',
                        },
                        '&.Mui-checked': {
                            color: '#1976d2',
                        }
                    }}
                />
            </div>
        );
    } else {
        return null;
    }
}

export default SelectMessageCheckbox;